import { useRef, useState } from "react";
import { http } from "@/lib/api";
import { Paperclip, FileArrowUp, ArrowSquareOut } from "@phosphor-icons/react";
import { toast } from "sonner";

const ACCEPT = ".pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png";

export const ReceiptButton = ({ expense, onUpdated }) => {
    const fileRef = useRef(null);
    const [busy, setBusy] = useState(false);

    const onFile = async (e) => {
        const file = e.target.files?.[0];
        if (!file) return;
        setBusy(true);
        const fd = new FormData();
        fd.append("file", file);
        try {
            const r = await http.post(
                `/expenses/${expense.expense_id}/receipt`,
                fd,
                {
                    headers: { "Content-Type": "multipart/form-data" },
                    timeout: 120000,
                },
            );
            toast.success("Justificante subido a Google Drive");
            onUpdated?.(r.data);
        } catch (err) {
            toast.error(err?.response?.data?.detail || "Error al subir el justificante");
        } finally {
            setBusy(false);
            if (fileRef.current) fileRef.current.value = "";
        }
    };

    return (
        <div className="inline-flex items-center gap-1">
            <input
                ref={fileRef}
                type="file"
                accept={ACCEPT}
                className="hidden"
                onChange={onFile}
                data-testid={`receipt-input-${expense.expense_id}`}
            />
            {expense.receipt_url ? (
                <>
                    <a
                        href={expense.receipt_url}
                        target="_blank"
                        rel="noreferrer"
                        title="Ver justificante en Drive"
                        className="inline-flex items-center gap-1 text-xs text-emerald-700 hover:text-emerald-900"
                        data-testid={`receipt-view-${expense.expense_id}`}
                    >
                        <Paperclip size={14} weight="fill" />
                        Ver
                        <ArrowSquareOut size={11} />
                    </a>
                    <button
                        onClick={() => fileRef.current?.click()}
                        disabled={busy}
                        title="Reemplazar justificante"
                        className="text-slate-400 hover:text-[#002BAF] p-0.5"
                        data-testid={`receipt-replace-${expense.expense_id}`}
                    >
                        <FileArrowUp size={14} />
                    </button>
                </>
            ) : (
                <button
                    onClick={() => fileRef.current?.click()}
                    disabled={busy}
                    title="Adjuntar justificante (PDF, JPG, PNG)"
                    className="inline-flex items-center gap-1 text-xs text-slate-500 hover:text-[#002BAF] border border-slate-200 hover:border-[#002BAF] rounded-sm px-2 py-1"
                    data-testid={`receipt-upload-${expense.expense_id}`}
                >
                    <FileArrowUp size={14} />
                    {busy ? "Subiendo…" : "Adjuntar"}
                </button>
            )}
        </div>
    );
};
